import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { UserContextService } from './user-context.service';

/** Маршруты с полным контекстом БФ+ОЕ (не узкий grant задачи/идеи). */
export const activateCtxDependedGuard: CanActivateFn = () => {
  const userContextSvc = inject(UserContextService);
  return userContextSvc.getUserContext().pipe(
    map((x) => {
      return !!x?.SelectedBF && !!x?.OrgUnit && !x?.isTaskScopedContext;
    })
  );
};
